export default import.meta.ROLLDOWN_FILE_URL_rAyFmqQR5K2RinDrmNFkvg